import { ObservableArray, View } from "binder"
import { SingleOptimalTransfer, WarehouseOptimalTransferViewModel } from "./warehouseOptimalTransfer-viewModel";
import { FileSelectorViewModel, ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class WarehouseOptimalTransferView extends View<WarehouseOptimalTransferViewModel>{
    GetViewUniqueId(): string {
        return "V-73A6C866-D128-45D2-BA52-544BEDABC692"
    }
    loadHtml(): string {
        let element = require('./warehouseOptimalTransfer.html').default;
        let style = require('./warehouseOptimalTransfer.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set warehouseOptimalTransferAmounts(v: ObservableArray<SingleOptimalTransfer>) { this._warehouseOptimalTransferAmounts = v; } public get warehouseOptimalTransferAmounts(): ObservableArray<SingleOptimalTransfer> { return this._warehouseOptimalTransferAmounts;} private _warehouseOptimalTransferAmounts: ObservableArray<SingleOptimalTransfer>;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
 
    import() {
        this.dataContext.import();
    }
    
    export() {
        this.dataContext.export();
    }
}
